import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "container" }

import {onMounted, reactive, ref, UnwrapRef,nextTick} from "vue";
import {designerTeamList, getById} from "@/api/designer";
import router from "@/router";
import DesignerTeamForm from "@/views/designer/designerTeamForm.vue";
import bindModal from "@/views/designer/bindModal.vue";
interface Data {
    loading: boolean;
    dataSource: any[];
    pagination: any,
    showForm: boolean,
    title: string,
    details:{
        id:string,
        name: string,
        leader: any,
        members: any[]
    }
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


const data: UnwrapRef<Data> = reactive({
    loading: true,
    dataSource: [],
    showForm: false,
    title: '',
    pagination: {
        size: "large",
        current: 1,
        pageSize: 10,
        total: 10,
        pageSizeOptions: ["10", "20", "30"], //可选的页面显示条数
        showTotal: (total: string) => {
            console.log(total);
            return " 共" + total + "条";
        }, //展示每页第几条至第几条和总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showSizeChanger: true, //是否可以改变pageSize
    },
    details:{
        id:'',
        name: '',
        leader: null,
        members: []
    }
});
const columns = ref([
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        width: 80,
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "名称",
        dataIndex: "name",
        key: "name",
    },
    {
        title: "负责人",
        dataIndex: "leader",
        key: "leader",
        customRender: ({ record }: any) => `${record.leader?record.leader.name:''}`,
    },
    {
        title: "成员",
        dataIndex: "members",
        key: "members",
        customRender: ({ record }: any) => `${record.members.map((e:any)=>{return e.name}).join(",")}`,
    },
    {
        title: "操作",
        dataIndex: "operation",
        width: "15%"
    },
])
const formState = reactive({
    keyword: "",
});
const teamFormRef = ref <any> ()
const handleTableChange = (pagination: any, value: any) => {
    data.pagination.pageSize = pagination.pageSize;
    data.pagination.current = pagination.current;
    formState.keyword = value
    onSearch();
};
const handleOk = (e: MouseEvent) => {
    console.log('teamFormRef',teamFormRef)
    teamFormRef.value.save()
    onSearch();
};
const onCancel = ()=>{
    data.showForm = false;
    onSearch();
}
function onSearch() {
    data.loading = true;
    designerTeamList({
        page: {
            pageSize: data.pagination.pageSize,
            currPage: data.pagination.current,
        },
        keyword: formState.keyword,
    }).then((res: { records: number; data: any[] }) => {
        data.loading = false;
        data.dataSource = res ? res.data : [];
        data.pagination.total = res ? res.records : 0;
    });
}
const onDepartment = (id: number) => {
    router.push({
        path: '/organization/department',
        query: {
            id: id,
            type: "designer_team",
        }
    })
}
const bindData=reactive({
    id:'',
    type:''
})
const bindModalRef=ref <any>()
const onBind = (id: string) => {
    bindData.id=id
    bindData.type='1'
    bindModalRef.value.data.showBindModal=true
    bindModalRef.value.data.treeData=[]
    bindModalRef.value.data.checkedKeys=[]
    bindModalRef.value.data.page.currPage=1
    bindModalRef.value.data.dentistName=''
    bindModalRef.value.data.total=0
    nextTick(()=>{
        bindModalRef.value.onSearch()
    })

}
function addHandle(){
    data.title='新增';
    data.details.id = ''
    data.showForm = true;
}
const onEdit = (id: string) => {
    data.title='修改';
    data.details.id = id
    data.showForm = true;
};

onMounted(()=>{
    onSearch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_btnPermission = _resolveDirective("btnPermission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: formState.keyword,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.keyword) = $event)),
                      placeholder: "关键字",
                      "allow-clear": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: onSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("查询")
                  ]),
                  _: 1
                }),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "primary",
                  style: {"margin":"0 8px"},
                  onClick: addHandle
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("新增")
                  ]),
                  _: 1
                })), [
                  [_directive_btnPermission, 'designer:add']
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { style: {"margin-top":"20px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          bordered: "",
          dataSource: data.dataSource,
          columns: columns.value,
          loading: data.loading,
          pagination: data.pagination,
          onChange: handleTableChange,
          scroll: { y: 400 },
          size: "small"
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.dataIndex === 'tagNames')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(record.tagNames, (item) => {
                  return (_openBlock(), _createBlock(_component_a_tag, {
                    color: "cyan",
                    key: item
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              : _createCommentVNode("", true),
            (column.dataIndex === 'operation')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (onEdit(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("修改")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_btnPermission, 'designer:update']
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (onDepartment(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("职位")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_btnPermission, 'designer:update']
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (onBind(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("绑定")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_btnPermission, 'designer:bind']
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "loading", "pagination"])
      ]),
      _: 1
    }),
    (data.showForm)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          visible: data.showForm,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((data.showForm) = $event)),
          title: data.title,
          onOk: handleOk
        }, {
          default: _withCtx(() => [
            _createVNode(DesignerTeamForm, {
              ref_key: "teamFormRef",
              ref: teamFormRef,
              id: data.details.id,
              onCancel: onCancel
            }, null, 8, ["id"])
          ]),
          _: 1
        }, 8, ["visible", "title"]))
      : _createCommentVNode("", true),
    _createVNode(bindModal, _mergeProps(bindData, {
      ref_key: "bindModalRef",
      ref: bindModalRef
    }), null, 16)
  ]))
}
}

})